import { useEffect, useState } from "react";
import { useGraphToken } from "../auth/useGraphToken";
import { fetchFeaturedRows, slideStatus, toSlide, ymd } from "../api/featured";
import { FEATURED_SLIDES, type FeaturedSlide } from "../data/featuredContent";

/** The banner's live slides from SharePoint, in order. Falls back to the
 *  built-in slides while the list is empty or can't be read, so the banner
 *  never goes blank. */
export function useFeaturedSlides(): { slides: FeaturedSlide[]; loading: boolean } {
  const getToken = useGraphToken();
  const [state, setState] = useState<{ slides: FeaturedSlide[]; loading: boolean }>({ slides: [], loading: true });

  useEffect(() => {
    let alive = true;
    void (async () => {
      let slides = FEATURED_SLIDES;
      try {
        const token = await getToken();
        const rows = await fetchFeaturedRows(token);
        if (rows.length) {
          const today = ymd(new Date());
          const live = rows.filter((r) => slideStatus(r, today) === "live");
          slides = await Promise.all(live.map((r) => toSlide(token, r.id, r)));
        }
      } catch {
        // keep the built-in slides
      }
      if (alive) setState({ slides, loading: false });
    })();
    return () => {
      alive = false;
    };
  }, [getToken]);

  return state;
}
